import React from 'react';
import { Link } from 'react-router-dom';
import { isVehicleDisclaimerGear } from './VehicleCategoryDisclaimer';
import { getPublicName } from './UserProfile';

export function GearPayThroughCallout() {
  return (
    <div className="gear-pay-through-callout">
      <strong>Pay only through ATTACK! Your Adventure</strong>
      <p>
        Complete your booking and payment on this site. Never send rental money through Venmo,
        Cash App, Zelle, or other off-platform methods if a member asks you to.
      </p>
    </div>
  );
}

export function GearInsuranceFaqLink({ gear, categories = [] }) {
  if (!isVehicleDisclaimerGear(gear, categories)) return null;

  return (
    <p className="gear-insurance-faq-link">
      Renting a vehicle, RV, UTV/ATV, or aviation listing?{' '}
      <Link to="/faq#vehicles">Read insurance and condition hold FAQ</Link>
    </p>
  );
}

export function GearReviewsPreview({ reviews = [] }) {
  if (!reviews.length) return null;

  const preview = [...reviews]
    .sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0))
    .slice(0, 3);

  return (
    <section className="gear-reviews-preview" aria-label="Renter reviews">
      <h2 className="gear-reviews-preview-title">What renters are saying</h2>
      {preview.map((review) => (
        <article key={review.id} className="gear-reviews-preview-item">
          <p className="gear-reviews-preview-stars">
            {'★'.repeat(Math.round(review.rating || 0))}
            {'☆'.repeat(5 - Math.round(review.rating || 0))}
            <span>{review.rating || 0}/5</span>
          </p>
          <p className="gear-reviews-preview-comment">
            {review.comment?.trim() || 'No written comment.'}
          </p>
          <p className="gear-reviews-preview-author">
            — {getPublicName(review.reviewerName, review.reviewerName || 'Member')}
          </p>
        </article>
      ))}
      {reviews.length > preview.length && (
        <a href="#rental-history" className="gear-reviews-preview-more">
          See all reviews and rental history
        </a>
      )}
    </section>
  );
}